import { UserStore } from "store/user";

const useUser = () => UserStore.useState(userState => userState);

export { useUser };
